const debounce = require('lodash.debounce');
// Assigning debounce as a global object
window.debounce = debounce;
